import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SpeciesDetailPage from './pages/SpeciesDetailPage';
import SourcesPage from './pages/SourcesPage';
import WildlifeMigrationTracker from './components/WildlifeMigrationTracker';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './admin/LoginPage';
import DashboardPage from './admin/DashboardPage';
import './index.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/explorer" element={<WildlifeMigrationTracker />} />
          <Route path="/species/:id" element={<SpeciesDetailPage />} />
          <Route path="/sources" element={<SourcesPage />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
